import React from "react";
import { Button, Tag } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { HELP_SITE_ORIGIN, openHelpUrl } from "../../core/help-docs";
import { PROGRAM_MODULE_LABELS } from "../../core/module-license";
import "./about.css";

const SPLASH_SRC = `${process.env.PUBLIC_URL || ""}/splash.svg`;

const formatLicenseDate = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  return match ? `${match[3]}.${match[2]}.${match[1]}` : value || "—";
};

const About = () => {
  const license = useSelector((state) => state.license.data);
  const licensedModules = new Set(license?.modules || []);

  return (
    <div className="about">
      <img className="about__splash" src={SPLASH_SRC} alt="Проффитель" />
      <section className="about__license" aria-label="Информация о лицензии">
        <div className="about__license-title">Лицензия № {license?.licenseNumber}</div>
        <div>Дата: {formatLicenseDate(license?.date)}</div>
        <div>
          Срок:{" "}
          {license?.isPerpetual
            ? "бессрочно"
            : `до ${formatLicenseDate(license?.expirationDate)}`}
        </div>
        <div className="about__modules">
          {Object.entries(PROGRAM_MODULE_LABELS).map(([moduleNumber, label]) => {
            const available = licensedModules.has(Number(moduleNumber));
            return (
              <Tag
                key={moduleNumber}
                color={available ? "success" : "default"}
                title={available ? "Доступен" : "Нет в лицензии"}
              >
                {label}
              </Tag>
            );
          })}
        </div>
        <div className="about__docs">
          <Button
            type="link"
            icon={<QuestionCircleOutlined />}
            onClick={() => openHelpUrl(`${HELP_SITE_ORIGIN}/`)}
          >
            База знаний
          </Button>
        </div>
      </section>
    </div>
  );
};

export default About;
